import { ReactNode } from 'react';
import { useUtmTracking } from '@modules/auth/sign-up/hooks/use-utm-tracking';

interface PublicContainerProps {
  children: ReactNode;
}

export function PublicContainer({ children }: PublicContainerProps) {
  useUtmTracking();
  return <>{children}</>;
}
